import {
  SalesTaxOverviewData,
  SalesTaxTransactionsActivityType,
} from '@commenda/api/sales-tax/types';
import StatsOverview from '../../common/overview';
import SalesTaxSectionLayout from '../../common/section-layout';
import { getTransactionOverviewStatsColor } from '../../utils';

interface TransactionOverviewProps {
  overviewData: SalesTaxOverviewData<SalesTaxTransactionsActivityType>[];
}

const TransactionOverview = ({ overviewData }: TransactionOverviewProps) => {
  return (
    <SalesTaxSectionLayout _className="px-0">
      <StatsOverview
        items={overviewData?.map((each) => {
          if (
            each.type === SalesTaxTransactionsActivityType.TOTAL_TRANSACTIONS
          ) {
            return {
              type: each.type,
              title: each.activityTitle,
              value: each.value,
            };
          }
          return {
            type: each.type,
            title: each.activityTitle,
            value: each.value,
            subTitle: '$',
            subTitlePosition: 'before',
          };
        })}
        getTextColorClass={getTransactionOverviewStatsColor}
      />
    </SalesTaxSectionLayout>
  );
};

export default TransactionOverview;
